/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import React from "react";
import { getAccessibleComponentToRender } from "./AccessibilityComponentHelper";
import { BULLET_POINT_CHARS } from "constants/constants";

const filterListMarker = item => {
  const x = item.children[0];
  const bulletPointPattern = new RegExp(`^[${BULLET_POINT_CHARS.join("")}]`);

  if (bulletPointPattern.test(x.contentDesc)) x.contentDesc = x.contentDesc.slice(1);
};

export const AccessibleListItemNode = ({ style, item, zoomLevel, pageIndex }) => {
  if (!item || !item.children || item.children.length === 0) return null;
  filterListMarker(item);
  return (
    <li style={style}>
      {item.children.map((child, childIndex) =>
        getAccessibleComponentToRender(child, zoomLevel, `listitemchild${childIndex}`, pageIndex, item)
      )}
    </li>
  );
};
